<template>
  <div class="calendar-bar">
    <div class="header">
      <div
        v-for="date in dates"
        :key="`day-${date.date}`"
        class="cell day"
        :class="{ sat: date.sat, sun: date.sun, holiday: date.holiday }"
      >
        {{ $t(`day[${date.day}]`) }}
      </div>
    </div>
    <div class="dates">
      <div
        v-for="date in dates"
        :key="date.date"
        class="cell date"
        :class="{ sat: date.sat, sun: date.sun, holiday: date.holiday }"
        @click="!date.disable && select(date.date)"
      >
        <!-- @slot 日付セルの書き換え -->
        <slot name="date" v-bind="date">{{ date.label }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
import { addDays } from 'date-fns'
import { times } from 'lodash'
import { formatDate, today } from '@/utils/date'

/**
 * カレンダーバー
 */
export default {
  name: 'CalendarBar',
  props: {
    /** 開始日 */
    startDate: { type: String, default: today },
    /** 日数 */
    dateCount: { type: Number, default: 14 },
    /** 祝日一覧 */
    holidays: { type: Array, default: () => [] },
  },
  computed: {
    dates() {
      return times(this.dateCount, index => {
        const date = addDays(this.startDate, index)
        const ymd = formatDate(date)
        const day = date.getDay()
        return {
          index,
          date: ymd,
          day,
          sat: day === 6,
          sun: day === 0,
          holiday: this.holidays.includes(ymd),
          label: formatDate(date, !index || date.getDate() === 1 ? 'M/D' : 'D'),
        }
      })
    },
  },
  methods: {
    select(date) {
      /**
       * 日のクリック
       * @event click
       * @type {string}
       */
      this.$emit('click', date)
    },
  },
}
</script>

<style lang="postcss" scoped>
.calendar-bar {
  overflow-x: auto;
  position: relative;
}

.header,
.dates {
  display: flex;
}

.cell {
  align-items: center;
  box-sizing: border-box;
  color: var(--very-dark-gray-1);
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  width: 48px;

  &.day {
    font-size: 10px;
    height: 24px;

    @media screen and (min-width: 768px) {
      font-size: 14px;
    }
  }

  &.date {
    border-color: var(--border-color);
    border-style: solid;
    border-width: 1px 1px 1px 0;
    cursor: pointer;
    min-height: 48px;

    &:first-child {
      border-width: 1px;
    }
  }

  &.sat {
    color: var(--brand-color);
  }

  &.sun,
  &.holiday {
    color: var(--strong-red);
  }

  @media screen and (min-width: 768px) {
    /* TODO: 要素数が可変なので違う指定をしたい */
    width: calc(908px / 14);
  }
}
</style>
